import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import apiService from '../../services/ApiService';
import { eventPublicPath } from '../../utils/eventSlug';
import PageLoader from '../ui/PageLoader';

/**
 * Redirect legacy /events/:slug URLs to /events/:organizer/:event-slug.
 */
const LegacyEventRedirect: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const [target, setTarget] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!slug) {
      setTarget(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await apiService.getPublicEventBySlug({ legacySlug: slug });
        if (cancelled) return;
        const base = eventPublicPath({
          slug: data.event.slug,
          organizer_username: data.event.organizer_username,
        });
        const suffix = location.pathname.replace(`/events/${slug}`, '') || '';
        setTarget(`${base}${suffix}${location.search}`);
      } catch {
        if (!cancelled) setTarget(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug, location.pathname, location.search]);

  if (target === undefined) {
    return <PageLoader message="Loading event…" />;
  }
  if (target) {
    return <Navigate to={target} replace />;
  }
  return <Navigate to="/events" replace />;
};

export default LegacyEventRedirect;
